import { z } from "zod";

import {
  ACCEPT_TERMS_MESSAGE,
  EMAIL_MESSAGE,
  EQUAL_PASSWORD_MESSAGE,
  MIN_LENGTH_MESSAGE,
  PASSWORD_RULE_MESSAGE,
} from "@/utils";

import { UserType } from "./register.types";
export const registerSchema = z
  .object({
    fullName: z
      .string()
      .min(3, { message: MIN_LENGTH_MESSAGE("10") })
      .max(30, { message: MIN_LENGTH_MESSAGE("30") }),
    email: z.string().email({ message: EMAIL_MESSAGE }),
    password: z
      .string()
      .min(6, { message: MIN_LENGTH_MESSAGE("6") })
      .regex(/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{6,}$/, {
        message: PASSWORD_RULE_MESSAGE,
      }),
    confirmPassword: z
      .string()
      .min(6, { message: MIN_LENGTH_MESSAGE("6") })
      .regex(/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{6,}$/, {
        message: PASSWORD_RULE_MESSAGE,
      }),
    acceptTerms: z.boolean().refine((val) => val === true, {
      message: ACCEPT_TERMS_MESSAGE,
    }),
    reCaptchaToken: z.string().optional(),
    userType: z.nativeEnum(UserType),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: EQUAL_PASSWORD_MESSAGE,
    path: ["confirmPassword"],
  });

export const registerSimpleSchema = z.object({
  fullName: z
    .string()
    .min(3, { message: MIN_LENGTH_MESSAGE("10") })
    .max(30, { message: MIN_LENGTH_MESSAGE("30") }),
  email: z.string().email({ message: EMAIL_MESSAGE }),
  acceptTerms: z.boolean().refine((val) => val === true, {
    message: ACCEPT_TERMS_MESSAGE,
  }),
  reCaptchaToken: z.string().optional(),
  userType: z.nativeEnum(UserType),
});
